/**
 * Centralized configuration constants for the timeline module.
 * Avoids magic values scattered across multiple files.
 */
export const TIMELINE_CONFIG = {
    /** Number of years per group on the horizontal timeline */
    YEARS_GROUP: 5,

    /** Pixel spacing between date links (responsive breakpoints) */
    DATE_INTERVALS: { desktop: 175, tablet: 150, mobile: 120 },

    /** Max location suggestions shown in the filter offcanvas */
    LOCATION_SUGGESTIONS_LIMIT: 5,

    /** Debounce delay (ms) before rebuilding timeline after a filter change */
    FILTER_DEBOUNCE_MS: 150,

    /** Font Awesome icon classes for navigation buttons */
    ICON_CLASS: {
        base: 'fas fa-2x',
        scrollLeft: 'fa-chevron-circle-left',
        scrollRight: 'fa-chevron-circle-right',
        prev: 'fa-arrow-circle-left',
        next: 'fa-arrow-circle-right',
    },
};
